import { styled } from "theme/default/styled";

export const SCustomMultipleSelectContainer = styled.div`
  width: 100%;
`;
